import { useState } from 'react';
import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function DemoMode() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const [currentStep, setCurrentStep] = useState(0);
  const [demoInvoice, setDemoInvoice] = useState(null);
  const [demoBalance, setDemoBalance] = useState({ PLN: 1000, EUR: 100, USD: 50, USDT: 25 });
  const [demoTransactions, setDemoTransactions] = useState([]);
  const [completed, setCompleted] = useState([]);

  // Тестовый человек
  const DEMO_PERSON = {
    first_name: 'Іван',
    last_name: 'Тестовенко',
    pesel: '95010112345',
    date_of_birth: '1995-01-01',
    citizenship: 'Україна',
    passport: 'FT123456',
    phone: '+48 500 123 456',
    email: 'ivan.testovenko@demo.workifypl.com',
    address: 'ul. Testowa 1/2, 00-001 Warszawa',
  };

  const DEMO_COMPANY = {
    name: 'DEMO TECH SP. Z O.O.',
    nip: '1234567890',
    krs: '0000999999',
    regon: '999888777',
    iban: 'PL00 0000 0000 0000 0000 0000 0000',
    bank: 'Demo Bank S.A.',
    address: 'ul. Demonstracyjna 10, 00-001 Warszawa',
  };

  const steps = [
    {
      id: 'profile',
      title: '👤 Профиль клиента',
      description: 'Посмотри как выглядит заполненный профиль',
      icon: '👤',
    },
    {
      id: 'contract',
      title: '📝 Gateway договор',
      description: 'Посмотри как подписывается договор',
      icon: '📝',
    },
    {
      id: 'work_permit',
      title: '🛂 Разрешение на работу',
      description: 'Посмотри процесс подачи на рабочий договор',
      icon: '🛂',
    },
    {
      id: 'invoice',
      title: '📄 Создать фактуру',
      description: 'Научись выставлять фактуры клиентам',
      icon: '📄',
    },
    {
      id: 'balance',
      title: '💰 Баланс и пополнение',
      description: 'Посмотри как работает баланс',
      icon: '💰',
    },
    {
      id: 'exchange',
      title: '💱 Обмен валют',
      description: 'Попробуй обменять валюту',
      icon: '💱',
    },
    {
      id: 'withdrawal',
      title: '💸 Вывод средств',
      description: 'Узнай как выводить деньги',
      icon: '💸',
    },
    {
      id: 'receipt',
      title: '🧾 Загрузка чека',
      description: 'Загрузи чек для возврата VAT',
      icon: '🧾',
    },
  ];

  function completeStep(stepId) {
    if (!completed.includes(stepId)) {
      setCompleted([...completed, stepId]);
    }
  }

  function createDemoInvoice() {
    const invoice = {
      id: 'DEMO-001',
      number: 'FV/DEMO/2026/001',
      client: 'Demo Client Sp. z o.o.',
      nip: '1234567890',
      items: [
        { name: 'Usługa konsultingowa', quantity: 10, unit: 'godz.', price: 150, vat: 23 },
      ],
      net: 1500,
      vat: 345,
      gross: 1845,
      date: new Date().toISOString().split('T')[0],
      status: 'demo',
    };
    setDemoInvoice(invoice);
    setDemoTransactions([
      ...demoTransactions,
      { id: Date.now(), type: 'income', amount: 1845, currency: 'PLN', desc: 'Faktura DEMO-001' }
    ]);
    completeStep('invoice');
  }

  function demoExchange() {
    const newBalance = { ...demoBalance };
    newBalance.PLN -= 100;
    newBalance.USDT += 24.5;
    setDemoBalance(newBalance);
    setDemoTransactions([
      ...demoTransactions,
      { id: Date.now(), type: 'exchange', amount: -100, currency: 'PLN', desc: 'Обмен PLN → USDT' },
      { id: Date.now() + 1, type: 'exchange', amount: 24.5, currency: 'USDT', desc: 'Обмен PLN → USDT' },
    ]);
    completeStep('exchange');
  }

  function demoWithdrawal() {
    const newBalance = { ...demoBalance };
    newBalance.PLN -= 500;
    setDemoBalance(newBalance);
    setDemoTransactions([
      ...demoTransactions,
      { id: Date.now(), type: 'withdrawal', amount: -500, currency: 'PLN', desc: 'Вывод на счёт (6% комиссия)' },
    ]);
    completeStep('withdrawal');
  }

  const allCompleted = completed.length >= 3;

  return (
    <div className="page">
      <BackButton />
      
      <div style={{
        background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
        borderRadius: 16,
        padding: 24,
        textAlign: 'center',
        marginBottom: 24,
      }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>🎮</div>
        <h1 style={{ margin: '0 0 8px' }}>ДЕМО РЕЖИМ</h1>
        <p style={{ opacity: 0.9, margin: 0 }}>
          Попробуй все функции без риска!
        </p>
        <div style={{
          marginTop: 16,
          padding: 8,
          background: 'rgba(255,255,255,0.2)',
          borderRadius: 8,
          fontSize: 14,
        }}>
          ⚠️ Это демо — операции не реальные
        </div>
      </div>

      {/* Progress */}
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        borderRadius: 12,
        padding: 16,
        marginBottom: 24,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
          <span>Прогресс обучения</span>
          <span>{completed.length} / {steps.length}</span>
        </div>
        <div style={{
          height: 8,
          background: 'rgba(255,255,255,0.1)',
          borderRadius: 4,
          overflow: 'hidden',
        }}>
          <div style={{
            width: `${(completed.length / steps.length) * 100}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #10b981, #3b82f6)',
            transition: 'width 0.3s',
          }} />
        </div>
      </div>

      {/* Demo Balance */}
      <div style={{
        background: 'rgba(16,185,129,0.1)',
        borderRadius: 12,
        padding: 16,
        marginBottom: 24,
      }}>
        <div style={{ fontWeight: 'bold', marginBottom: 12 }}>💰 Демо баланс</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8 }}>
          {Object.entries(demoBalance).map(([currency, amount]) => (
            <div key={currency} style={{
              background: 'rgba(255,255,255,0.1)',
              borderRadius: 8,
              padding: 8,
              textAlign: 'center',
            }}>
              <div style={{ fontWeight: 'bold' }}>{amount.toFixed(2)}</div>
              <div style={{ fontSize: 11, opacity: 0.7 }}>{currency}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Steps */}
      <div style={{ marginBottom: 24 }}>
        {steps.map((step, index) => (
          <div
            key={step.id}
            onClick={() => setCurrentStep(index)}
            style={{
              background: currentStep === index ? 'rgba(99,102,241,0.2)' : 'rgba(255,255,255,0.05)',
              borderRadius: 12,
              padding: 16,
              marginBottom: 8,
              cursor: 'pointer',
              border: completed.includes(step.id) ? '2px solid #10b981' : '2px solid transparent',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <div style={{ fontSize: 32 }}>{step.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 'bold' }}>{step.title}</div>
                <div style={{ fontSize: 13, opacity: 0.7 }}>{step.description}</div>
              </div>
              {completed.includes(step.id) && (
                <div style={{ fontSize: 24, color: '#10b981' }}>✅</div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Step Content */}
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        borderRadius: 12,
        padding: 20,
        marginBottom: 24,
      }}>
        {/* ── Profile ── */}
        {currentStep === 0 && (
          <div>
            <h3 style={{ marginTop: 0 }}>👤 Профиль тестового клиента</h3>
            <p>Так выглядит заполненный профиль клиента в системе:</p>
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 16, lineHeight: 2 }}>
              <div>👤 <b>{DEMO_PERSON.first_name} {DEMO_PERSON.last_name}</b></div>
              <div>📱 {DEMO_PERSON.phone}</div>
              <div>📧 {DEMO_PERSON.email}</div>
              <div>🆔 PESEL: {DEMO_PERSON.pesel}</div>
              <div>🎂 {DEMO_PERSON.date_of_birth}</div>
              <div>🌍 {DEMO_PERSON.citizenship}</div>
              <div>🛂 Паспорт: {DEMO_PERSON.passport}</div>
              <div>🏠 {DEMO_PERSON.address}</div>
            </div>
            <button className="btn btn-primary" style={{ marginTop: 16, width: '100%' }} onClick={() => { completeStep('profile'); setCurrentStep(1); }}>
              ✅ Понятно, дальше →
            </button>
          </div>
        )}

        {/* ── Contract ── */}
        {currentStep === 1 && (
          <div>
            <h3 style={{ marginTop: 0 }}>📝 Gateway договор</h3>
            <p>Так выглядит подписание Gateway-договора:</p>
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 16, lineHeight: 2 }}>
              <div><b>Компания:</b> {DEMO_COMPANY.name}</div>
              <div><b>NIP:</b> {DEMO_COMPANY.nip}</div>
              <div><b>KRS:</b> {DEMO_COMPANY.krs}</div>
              <div><b>Адрес:</b> {DEMO_COMPANY.address}</div>
              <div style={{ marginTop: 12, padding: 12, background: 'rgba(16,185,129,0.2)', borderRadius: 8 }}>
                ✅ Условия: активация 1 200 PLN + 350 PLN/мес + 6% комиссии
              </div>
            </div>
            <a href="https://api.workifypl.com/demo/pdf/gateway-contract" target="_blank" rel="noopener" style={{ display: 'block', marginTop: 16 }}>
              <button className="btn btn-secondary" style={{ width: '100%' }} type="button">
                📥 Скачать демо Gateway договор (PDF)
              </button>
            </a>
            <button className="btn btn-primary" style={{ marginTop: 8, width: '100%' }} onClick={() => { completeStep('contract'); setCurrentStep(2); }}>
              ✍️ Подписать (демо) →
            </button>
          </div>
        )}

        {/* ── Work Permit ── */}
        {currentStep === 2 && (
          <div>
            <h3 style={{ marginTop: 0 }}>🛂 Рабочий договор / Разрешение</h3>
            <p>Процесс оформления рабочего договора:</p>
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 16 }}>
              <div style={{ marginBottom: 8 }}>1️⃣ Выбор типа договора: <b>Umowa zlecenie</b></div>
              <div style={{ marginBottom: 8 }}>2️⃣ Должность: <b>Konsultant</b></div>
              <div style={{ marginBottom: 8 }}>3️⃣ Ставка: <b>30 PLN/час</b></div>
              <div style={{ marginBottom: 8 }}>4️⃣ Период: <b>01.03.2026 — 31.05.2026</b></div>
              <div style={{ marginTop: 12, padding: 12, background: 'rgba(59,130,246,0.2)', borderRadius: 8, fontSize: 13 }}>
                ℹ️ После подписания договора система генерирует PDF и уведомляет менеджера
              </div>
            </div>
            <a href="https://api.workifypl.com/demo/pdf/work-contract" target="_blank" rel="noopener" style={{ display: 'block', marginTop: 16 }}>
              <button className="btn btn-secondary" style={{ width: '100%' }} type="button">
                📥 Скачать демо рабочий договор (PDF)
              </button>
            </a>
            <button className="btn btn-primary" style={{ marginTop: 8, width: '100%' }} onClick={() => { completeStep('work_permit'); setCurrentStep(3); }}>
              ✅ Понятно, дальше →
            </button>
          </div>
        )}

        {/* ── Invoice (was step 0, now step 3) ── */}
        {currentStep === 3 && (
          <div>
            <h3 style={{ marginTop: 0 }}>📄 Создание фактуры</h3>
            <p>Фактура — это документ для получения оплаты от клиентов (фирм).</p>
            
            {!demoInvoice ? (
              <>
                <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 16, marginBottom: 16 }}>
                  <div style={{ marginBottom: 8 }}><b>Клиент:</b> Demo Client Sp. z o.o.</div>
                  <div style={{ marginBottom: 8 }}><b>Услуга:</b> Usługa konsultingowa</div>
                  <div style={{ marginBottom: 8 }}><b>Количество:</b> 10 часов × 150 PLN</div>
                  <div style={{ marginBottom: 8 }}><b>Нетто:</b> 1 500 PLN</div>
                  <div style={{ marginBottom: 8 }}><b>VAT (23%):</b> 345 PLN</div>
                  <div><b>Брутто:</b> 1 845 PLN</div>
                </div>
                <button className="btn btn-primary" style={{ width: '100%' }} onClick={createDemoInvoice}>
                  📄 Создать демо-фактуру
                </button>
                <a href="https://api.workifypl.com/demo/pdf/invoice" target="_blank" rel="noopener" style={{ display: 'block', marginTop: 8 }}>
                  <button className="btn btn-secondary" style={{ width: '100%' }} type="button">
                    📥 Скачать демо-фактуру (PDF)
                  </button>
                </a>
              </>
            ) : (
              <div style={{ background: 'rgba(16,185,129,0.2)', borderRadius: 8, padding: 16, textAlign: 'center' }}>
                <div style={{ fontSize: 48, marginBottom: 8 }}>✅</div>
                <div style={{ fontWeight: 'bold' }}>Фактура {demoInvoice.number} создана!</div>
                <div style={{ opacity: 0.8, marginTop: 4 }}>+1 845 PLN на демо-баланс</div>
              </div>
            )}
          </div>
        )}

        {currentStep === 4 && (
          <div>
            <h3 style={{ marginTop: 0 }}>💰 Баланс и пополнение</h3>
            <p>Ваш баланс показывает деньги в разных валютах.</p>
            
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Способы пополнения:</div>
              <ul style={{ paddingLeft: 20 }}>
                <li>💳 Банковский перевод</li>
                <li>💎 Криптовалюта USDT (TRC20)</li>
                <li>🧾 Возврат VAT с чеков</li>
                <li>📄 Оплата фактур от клиентов</li>
              </ul>
            </div>
            
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={() => completeStep('balance')}>
              ✅ Понятно!
            </button>
          </div>
        )}

        {currentStep === 5 && (
          <div>
            <h3 style={{ marginTop: 0 }}>💱 Обмен валют</h3>
            <p>Обменивайте валюту прямо в приложении!</p>
            
            <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}><b>Отдаёте:</b> 100 PLN</div>
              <div style={{ marginBottom: 8 }}><b>Получаете:</b> ~24.5 USDT</div>
              <div style={{ marginBottom: 8 }}><b>Курс:</b> 1 USDT = 4.05 PLN</div>
              <div><b>Комиссия:</b> 3% (при покупке USDT)</div>
            </div>
            
            {!completed.includes('exchange') ? (
              <button className="btn btn-primary" style={{ width: '100%' }} onClick={demoExchange}>
                💱 Выполнить демо-обмен
              </button>
            ) : (
              <div style={{ background: 'rgba(16,185,129,0.2)', borderRadius: 8, padding: 16, textAlign: 'center' }}>
                ✅ Обмен выполнен!
              </div>
            )}
          </div>
        )}

        {currentStep === 6 && (
          <div>
            <h3 style={{ marginTop: 0 }}>💸 Вывод средств</h3>
            <p>Выводите деньги на банковский счёт или крипто-кошелёк!</p>
            
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Способы вывода:</div>
              <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 12, marginBottom: 8 }}>
                🏦 <b>Банковский счёт</b> — комиссия 6%
              </div>
              <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 12, marginBottom: 8 }}>
                💎 <b>Крипто-кошелёк</b> — только сетевая комиссия
              </div>
              <div style={{ background: 'rgba(0,0,0,0.2)', borderRadius: 8, padding: 12 }}>
                💵 <b>Наличные</b> — в офисе (по договорённости)
              </div>
            </div>
            
            {!completed.includes('withdrawal') ? (
              <button className="btn btn-primary" style={{ width: '100%' }} onClick={demoWithdrawal}>
                💸 Демо-вывод 500 PLN
              </button>
            ) : (
              <div style={{ background: 'rgba(16,185,129,0.2)', borderRadius: 8, padding: 16, textAlign: 'center' }}>
                ✅ Заявка на вывод создана!
              </div>
            )}
          </div>
        )}

        {currentStep === 7 && (
          <div>
            <h3 style={{ marginTop: 0 }}>🧾 Возврат VAT</h3>
            <p>Загружайте чеки и получайте до 50% VAT обратно!</p>
            
            <div style={{ background: 'rgba(245,158,11,0.1)', borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <div style={{ fontWeight: 'bold', marginBottom: 8 }}>Пример:</div>
              <div>Купил ноутбук за 5 000 PLN</div>
              <div>VAT (23%) = 935 PLN</div>
              <div style={{ color: '#10b981', fontWeight: 'bold', marginTop: 8 }}>
                → Возврат 50%: +467 PLN на баланс!
              </div>
            </div>
            
            <ol style={{ paddingLeft: 20, marginBottom: 16 }}>
              <li>Сфотографируй фактуру с VAT</li>
              <li>Загрузи в раздел "Чеки"</li>
              <li>Дождись одобрения</li>
              <li>Получи деньги на баланс!</li>
            </ol>
            
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={() => completeStep('receipt')}>
              ✅ Понятно!
            </button>
          </div>
        )}
      </div>

      {/* Demo Transactions */}
      {demoTransactions.length > 0 && (
        <div style={{
          background: 'rgba(255,255,255,0.05)',
          borderRadius: 12,
          padding: 16,
          marginBottom: 24,
        }}>
          <div style={{ fontWeight: 'bold', marginBottom: 12 }}>📊 Демо-транзакции</div>
          {demoTransactions.map(tx => (
            <div key={tx.id} style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: '1px solid rgba(255,255,255,0.1)',
            }}>
              <span style={{ opacity: 0.8 }}>{tx.desc}</span>
              <span style={{ color: tx.amount >= 0 ? '#10b981' : '#ef4444', fontWeight: 'bold' }}>
                {tx.amount >= 0 ? '+' : ''}{tx.amount} {tx.currency}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Completion */}
      {allCompleted && (
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          borderRadius: 16,
          padding: 24,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 8 }}>🎉</div>
          <h2 style={{ margin: '0 0 8px' }}>Отлично!</h2>
          <p style={{ margin: '0 0 16px', opacity: 0.9 }}>
            Ты освоил основные функции. Теперь можно работать по-настоящему!
          </p>
          <button
            className="btn btn-primary"
            style={{ marginRight: 8 }}
            onClick={() => setPage('onboarding')}
          >
            🚀 Оформить подписку
          </button>
          <button
            className="btn"
            style={{ background: 'rgba(255,255,255,0.2)' }}
            onClick={() => setPage('dashboard')}
          >
            🏠 На главную
          </button>
        </div>
      )}
    </div>
  );
}
